import {I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from 'lf-at-theme';
import {ktI18nFn} from '../../../shared';

/**
 * Non-Union form i18n object for the pt-PT locale.
 */
export const nonUnionFormI18nPtPT: Record<string, any> = {
  '/non-union-form': {
    label: 'Regime Extra-União - Registo',
    nationalTaxReference: 'Número de Identificação Fiscal',
    nationalTaxRefHelp: 'O país de sede selecionado ou a sua região',
    validations: {
      BUSINESS_AND_ISSUING_COUNTRIES_NOT_EQUAL: '[País do número fiscal](lf://./issuingCountry) tem de ser igual ao [País de sede](lf://./countryOfBusiness) ou à [Região/Território](lf://./cobRegion).',
      COB_REGION_SHOULD_BE_USED: ktI18nFn(({parentA2, regionA2}) => `Para usar o [País do número fiscal](lf://./issuingCountry) escolhido, o [País Sede](lf://./countryOfBusiness) e [Região/Território](lf://./cobRegion) devem ser mudados respetivamente para ${parentA2} e ${regionA2}.`),
      ISSUER_COUNTRY_NOT_EQUAL_PARENT: '[País do número fiscal](lf://./issuingCountry) tem de ser igual ao [País Sede](lf://./countryOfBusiness).',
      ISSUING_COUNTRY_NOT_EQUAL_REGION: '[País do número fiscal](lf://./issuingCountry) tem de ser igual à [Região/Território de Sede](lf://./cobRegion).',
      ISSUING_COUNTRY_MS_IS_EU_COUNTRY: 'Só pode indicar um Estado-Membro como [Emissor de Número de Identificação Fiscal](lf://./issuingCountry) quando os números fiscais associados a essa região têm obrigatoriamente esse Estado-Membro como emissor. Deve indicar o mesmo valor que em [Região](lf://./cobRegion).',
      ISSUER_CODE_NOT_COUNTRY: '[País do número fiscal](lf://./issuingCountry) tem de ser igual a um país de fora da União.',
    }
  },

  '/?/meetsConditions': {
    label: 'Confirmo que reúno as condições para me registar neste regime.'
  },


  '/?/currVatId': {
    netpVat: 'Número de Identificação Fiscal',
    netpHelp: 'Número de identificação individual para efeitos do IVA atribuído pelo Estado-Membro de identificação nos termos do artigo 362.o da Diretiva 2006/112/CE',
  },

  '/?/currVatId/vatIdNum': {
    legend: 'Preenchido pelo sistema após aprovação'
  },

  '/?/notEstablishedInEU': {
    label: 'Não estabelecido na UE',
    [I18N_VALUE_CODE_KEY]: '16.1'
  },

  '/?/issuingCountry': {
    label: 'Emissor TIN',
    [I18N_VALUE_CODE_KEY]: '2',
    legend: 'Código país emissor',
  },
  '/?/nationalTaxNumber': {
    label: 'TIN',
    legend: 'TIN no país',
  },

  '/?/bankAccountInfo': {
    validations: {
      IBAN_OBAN_BOTH_NOT_ALLOWED: 'Não pode preencher o campo OBAN se possui um número IBAN'
    }
  },
  '/?/bankAccountInfo/oban': {
    label: 'Número OBAN (caso não possua IBAN)',
    [I18N_VALUE_CODE_KEY]: '11',
    validations: {
      OBAN_NOT_ALLOWED: 'Não pode preencher o campo OBAN se possui um número IBAN'
    }
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'País em que o sujeito passivo tem a sua sede'
  },

  // Relevant Dates
  '/?/relevantDates/registrationReqDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Data do pedido de registo no regime apresentado pelo sujeito passivo'
  },

  '/?/prevOrCurrOssVatId': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de identificação individual IVA atribuído(s) pelo Estado-Membro de identificação nos termos dos artigos 362.o, 369.o-D ou 369.o-Q da Diretiva 2006/112/CE, caso o sujeito passivo tenha utilizado anteriormente ou esteja atualmente a utilizar um desses regimes'
  },

  // Consent / Change of MSID
  '/?/registration': {
    label: 'Confirmações',
  }
};
